import jsPDF from 'jspdf'
import 'jspdf-autotable'
import './Roboto-Regular-normal'
import './svg'

export default jsPDF;
